import { queryOptions, useQuery } from '@tanstack/react-query';
import { SchemaTokenDto } from '../generated/apiTypes';
import { dataOrThrow, fetchClient } from '../lib/apiClient';
import { Gwei } from '../lib/gwei';

export const transformTokenDetails = (tokenDetails: SchemaTokenDto) => ({
  ...tokenDetails,
  depositFee: Gwei.toGwei(tokenDetails.depositFee),
  minDeposit: Gwei.toGwei(tokenDetails.minDeposit),
  withdrawFee: Gwei.toGwei(tokenDetails.withdrawFee),
});

export type TokenDetails = ReturnType<typeof transformTokenDetails>;

export const tokenDetailsQuery = () =>
  queryOptions({
    queryKey: ['GET', '/v1/token'] as const,
    queryFn: async ({ queryKey, signal }): Promise<TokenDetails[] | null> => {
      const [method, url] = queryKey;
      const { data } = await fetchClient[method](url, { signal }).then(dataOrThrow);
      return data?.data.map(transformTokenDetails) ?? null;
    },
  });

export const useTokenDetails = () => useQuery(tokenDetailsQuery());
